// extracted by mini-css-extract-plugin
export default {"routineblock":"hR","container":"iR","carousel":"jR","routine":"kR","heading":"lR","routinelist":"mR","routineitem":"nR","routineimg":"oR","routinedesc":"pR","routinename":"qR","routinetext":"rR","carouselwrap":"sR"};
    if(module.hot) {
      // 1713809679081
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  